import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotAllowedComponent } from './auth/not-allowed/not-allowed.component';
import { authGuard } from './auth/auth-guard.service';

const routes: Routes = [
  {
    path: "",
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: "photobooth",
    redirectTo: "mission-control/tools/photobooth",
    pathMatch: "prefix",
  },
  {
    path: "incidents",
   loadChildren: () => import('./routed-modules/incidents/incidents.module').then(m => m.IncidentsModule),
  },
  {
    path: "contact-card",
    loadChildren: () => import('./routed-modules/contact-card/contact-card.module').then(m => m.ContactCardModule),
  },
  {
    path: "consulting",
    loadChildren: () => import('./routed-modules/consulting/consulting.module').then(m => m.ConsultingModule),
  },
  {
    path: "executive-reporting",
    loadChildren: () => import('./routed-modules/executive-reporting/executive-reporting.module').then(m => m.ExecutiveReportingModule),
  },
  {
    path: "finance",
    loadChildren: () => import('./routed-modules/finance/finance.module').then(m => m.FinanceModule),
  },
  {
    path: "mission-control",
    loadChildren: () => import('./routed-modules/mission-control/mission-control.module').then(m => m.MissionControlModule),
  },
/*   {
    path: "recruiting",
    loadChildren: () => import('./routed-modules/recruiting/promo-codes.module').then(m => m.PromoCodesModule),
  }, */
  {
   path: "roots",
    loadChildren: () => import('./routed-modules/roots/roots.module').then(m => m.RootsModule), 
  },
  {
    path: "trip-staffing",
    loadChildren: () => import('./routed-modules/trip-staffing/trip-staffing.module').then(m => m.TripStaffingModule)
  },
  {
    path: "document-library/:type",
    loadComponent: () => import('./routed-components/document-library/document-library.component').then(m => m.DocumentLibraryComponent),
    title: "Document Library | Mission Control"
  },
  {
    path: "trip-leading",
    loadChildren: () => import('./routed-modules/trip-leading/trip-leading.module').then(m => m.TripLeadingModule)
  },
  {
    path: "disaster-response",
    loadChildren: () => import('./routed-modules/disaster-response/disaster-response.module').then(m => m.DisasterResponseModule)
  },
  {
    path: "recruiting",
    loadChildren: () => import('./routed-modules/recruiting/recruiting.module').then(m => m.RecruitingModule)
  },
  {
    path: "kpi",
    loadChildren: () => import('./routed-modules/kpi/kpi.module').then(m => m.KpiModule)
  },
  {
    path: "mc-hosted",
    loadChildren: () => import('./routed-modules/mc-hosted/mc-hosted.module').then(m => m.McHostedModule)
  },
  { path: "forms",
    loadChildren: () => import('./routed-modules/ppm-forms/ppm-forms-routing').then(r => r.PpmFormsRoutes)
  },
  {
    path: "login",
    loadComponent: () => import('./auth/sign-in-page/sign-in-page.component').then(m => m.SignInPageComponent),
    title: "Sign In | Mission Control"
  },
  {
    path: "forgot-password",
    loadComponent: () => import('./auth/forgot-password-landing/forgot-password-landing.component').then(m => m.ForgotPasswordLandingComponent),
    title: "Forgot Password | Mission Control"
  },
  {
    path: "trips",
    loadChildren: () => import('./routed-modules/trips/trips.module').then(m => m.TripsModule),
  },
  {
    path: "staff",
    loadChildren: () => import('./routed-modules/staff/staff.module').then(m => m.StaffModule)
  },
  {
    path: "tech",
    children: [
      {
        path: "revalidate-main-site",
        loadComponent: () => import('./routed-components/tech/revalidate-main-site/revalidate-main-site.component').then(m => m.RevalidateMainSiteComponent),
        canActivate: [authGuard(['it'])],
        title: "Revalidate Main Site | Mission Control"
      },
      {
        path: "delete-journal-comment",
        loadComponent: () => import('./routed-components/tech/delete-journal-comment/delete-journal-comment.component').then(m => m.DeleteJournalCommentComponent),
        canActivate: [authGuard(['it'])],
        title: "Delete Journal Comment | Mission Control"
      },
      {
        path: "rebuild-payment-schedule",
        loadComponent: () => import('./routed-components/tech/rebuild-payment-schedule/rebuild-payment-schedule.component').then(m => m.RebuildPaymentScheduleComponent),
        canActivate: [authGuard(['it'])],
        title: "Rebuild Payment Schedule | Mission Control"
      }
    ]
  },
  {
    path: "fundraising",
    children: [
      {
        path: "donor-search",
        loadComponent: () => import('./components/fundraising/donor-search/donor-search.component').then(m => m.DonorSearchComponent),
        canActivate: [authGuard()],
        title: "Donor Search | Mission Control"
      },
      {
        path: "donation-import-review",
        loadComponent: () => import('./components/fundraising/donation-import-review/donation-import-review.component').then(m => m.DonationImportReviewComponent),
        canActivate: [authGuard(["it", "finance"])],
        title: "Donation Import Review | Mission Control"
      }
    ]
  },
  {
    path: "not-allowed",
    component: NotAllowedComponent,
    title: "Access Denied | Mission Control"
  },
  {
    path: "incident-reports",
    redirectTo: "incidents/incident-reports",
    pathMatch: "prefix"
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {enableTracing: false})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
